const user_management_en = {
  account:'account',
  reg_time:'reg time',
  start_time:'start time',
  end_time:'end time',

  empty_account:'Please enter the account number',
  empty_name:'Please enter a name',
  empty_password:'Please input a password',
  pwd_condition:'The length is between 6 and 14 characters',
  pwd_again:'Please enter the password again',
  pwd_inconsistent:'The two passwords are inconsistent',
  empty_email:'Please enter email address',
  email_error:'Please enter the correct email address',
  empty_dept:'Please select a department',
  roles_error:'Please select the role to be assigned',

  edit_user_info:'edit user information',
  reset_pwd:'Reset password to "111111"?'
}

export default user_management_en



// WEBPACK FOOTER //
// ./src/common/lang/user_management/user_management_en.js